import Container from '@mui/material/Container';
import React, { useEffect, useState, useContext } from 'react'
import axios from "axios"
import { Table, TableCell, TableContainer, TableRow, Paper, tableCellClasses, TextField, Button, Autocomplete, TableBody, IconButton } from '@mui/material';
import { Box, styled } from '@mui/system';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AuthContext } from '../authContext/AuthContext'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1776d1',
    color: 'white',
  }
}));

const Transfer = () => {
  const isMounted = React.useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const [items, setItems] = useState([]);
  const {user, shop} = useContext(AuthContext)
  const [shopOptions, setShopOptions] = useState([]);
  const [shopMap, setShopMap] = useState(shop ? { F: "Factory", [shop.shopkey]: shop.shopname } : { F: "Factory" });

  const createItem = (_id, itemKey, itemName) => {
    return { 
      _id,
      itemKey, 
      itemName
    };
  }

  useEffect(() => {
    const getShops = async() => {
      try {
        const res = await axios.get("/shops", {headers: {token:"Bearer " + user.token}})
        if (!isMounted.current) return;
        const map = { F: "Factory" };
        const options = ["F"];
        res.data.forEach(s => {
          map[s.shopkey] = s.shopname;
          options.push(s.shopkey);
        });
        setShopMap(map);
        setShopOptions(options);
        setTo(options.find(o => o !== shop.shopkey && o !== 'F') || 'F');
      } catch (err) {
        console.log(err)
      }
    };
    getShops();

    const getItems = async() => {
      try {
        const res = await axios.get("/items", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        if (!isMounted.current) return;
        const data = [];
        res.data.map((item) => (item.delete === false && data.push(createItem(item._id, item.itemKey, item.itemName))));
        setItems(data)
      } catch (err) {
        console.log(err)
      }
    };
    getItems();
  },[user, shop]);

  const deleteItem = (id) => {
    setCart(cart.filter((c) => (c.id !== id)));
  }

  const [cart, setCart] = useState([]);
  const [from, setFrom] = useState(shop.shopkey)
  const [to, setTo] = useState('')
  const [qty, setQty] = useState('')
  const [selectedItem, setSelectedItem] = useState();
  const [disableAddButton, setDisableAddButton] = useState(true);
  
  const handleClickAddCart = () => {
    let updatedCart = cart;
    const transactionDate = new Date()
    let type = "Transfer Out"
    let index = 1
    if(from === "F") {
      type = "Inward"
    } else if(to !== "F") {
      updatedCart.push({itemKey: selectedItem.itemKey, itemName: selectedItem.itemName, from: to, to: from, qty, type: "Transfer In", transactionDate, shopkey: to, id: cart.length + index});
      index = index + 1
    }
    updatedCart.push({itemKey: selectedItem.itemKey, itemName: selectedItem.itemName, from, to, qty, type, transactionDate, shopkey: shop.shopkey, id: cart.length + index});
    index = index + 1
    setCart(updatedCart);
    setQty('')
    setDisableAddButton(true)
  };

  const handleAddTransaction = async() => {
    try {
      await axios.post("/transactions", cart, {headers: {token:"Bearer " + user.token}})
      setCart([])
    } catch (err) {
      console.log(err)
    }
  }
  const handleQtyChange = (value) => {
    if((value && value <=0) || (from === to)) {
      setDisableAddButton(true);
      setQty('');
    } else {
      setDisableAddButton(false);
      setQty(value);
    }
  }
  return (
    <div>
       <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
        <Box sx={{paddingTop: .5, paddingLeft: .5, paddingRight: .5}}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: "92vh", minHeight: "92vh" }}>
          <Table size="small" stickyHeader>
            <TableBody>
            <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <TextField select value={from} label="From" onChange={(event)=> setFrom(event.target.value)} variant="standard" SelectProps={{native: true}} fullWidth>
                      {shop && <option key={shop.shopkey} value={shop.shopkey}>{shopMap[shop.shopkey]}</option>}
                      <option key="F" value="F">{shopMap["F"]}</option>
                    </TextField>
                  </TableCell>
                  <TableCell>
                    <TextField select value={to} label="To" onChange={(event)=> setTo(event.target.value)} variant="standard" SelectProps={{native: true}} fullWidth>
                      {shopOptions.map((o) => (<option key={o} value={o}>{shopMap[o]}</option>))}
                    </TextField>
                  </TableCell>
                  <TableCell colSpan="3">
                    <Autocomplete
                      id="searchItem"
                      disablePortal
                      options={items}
                      sx={{ width: 300 }}
                      renderInput={
                        (params) => <TextField sx={{ width: 430 }} {...params} label="Item Name" inputProps={{...params.inputProps}}
                        variant="standard"
                        size="small"/>
                      }
                      size="small"
                      onHighlightChange= {(event, option, reason) => {
                        setSelectedItem(option);
                      }}
                      getOptionLabel={(option) => option.itemName.toUpperCase() }
                      renderOption={(props, option) => (
                        <Box {...props} sx={{ position: "sticky" }} key={option._id}>
                          {option.itemKey} | {option.itemName.toUpperCase()}
                        </Box>                
                      )}
                    />
                  </TableCell>
                  <TableCell><TextField label="Qty" variant="standard" fullWidth  size="small" value={qty} type="number" min="0.1" onChange={(event)=> handleQtyChange(event.target.value)}/></TableCell>
                  <TableCell colSpan="3"><IconButton onClick={() => handleClickAddCart()} disabled={disableAddButton}><AddCircleIcon size="small" color="primary" /></IconButton></TableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>Sno #</StyledTableCell>
                <StyledTableCell>From</StyledTableCell>
                <StyledTableCell>To</StyledTableCell>
                <StyledTableCell>ItemName</StyledTableCell>
                <StyledTableCell>ItemKey</StyledTableCell>
                <StyledTableCell>Type</StyledTableCell>
                <StyledTableCell align="right">Quantity</StyledTableCell>
                <StyledTableCell />
              </TableRow>
              {cart.map((citem, index) => (
                <TableRow key={index} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{shopMap[citem.from]}</TableCell>
                  <TableCell>{shopMap[citem.to]}</TableCell>
                  <TableCell>{citem.itemName}</TableCell>
                  <TableCell>{citem.itemKey}</TableCell>
                  <TableCell>{citem.type}</TableCell>
                  <TableCell align="right">{citem.qty}</TableCell>
                  <TableCell><IconButton onClick={() => deleteItem(citem.id)}><RemoveCircleIcon size="small" color="error"/></IconButton></TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan="6"/>
                <TableCell colSpan="2">
                  <Button onClick={handleAddTransaction} variant="outlined" fullWidth disabled={cart.size === 0}> Submit Transfer </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        </Paper>
        </Box>
      </Container>
    </div>
  )
}

export default Transfer
